import React from 'react';
import { DowntimeIcon } from './DowntimeIcon';

export function DowntimeModal({ title, message, actionButton }) {
  return (
    <div className="as-Error-body">
      <h2 className="as-Error-title">{title}</h2>
      {
        /* eslint-disable  react/no-danger */
        <p
          className="as-Error-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        /* eslint-enable */
      }

      <div className="as-Error-icon">
        <DowntimeIcon />
      </div>
      {actionButton.isVisible && (
        <a
          href={actionButton.href}
          className="as-Error-actionButton"
          target="_blank"
          rel="noopener noreferrer"
        >
          {actionButton.title}
        </a>
      )}
    </div>
  );
}
